import Button from "@/components/units/button/Button"
import InvestmentCardField from "../InvestmentCardField"
import Icon from "@/components/units/Icon";

import { navigateToURLorOnboarding } from "@/utility/navigate"

const StocksCardContent = ({ data, isDematUser=false }) => {

    const investment = {
        current: data?.current?.toFixed(2),
        investment: data?.investment?.toFixed(2),
        unRealizedGainLoss: data?.unRealizedGainLoss?.toFixed(2),
        unRealizedGainLossPercent: data?.unRealizedGainLossPercent?.toFixed(2),
        todayPnL: data?.todayPnL?.toFixed(2),
        todayPnLPercent: data?.todayPnLPercent?.toFixed(2)
    }

    if (!data || data.hasError) {
        return <div className="tw-pt-4 xs:tw-pt-10 tw-w-full tw-flex tw-flex-col xs:tw-gap-1 sm:tw-gap-2 tw-justify-between">
            <div className="tw-flex tw-justify-center tw-gap-2">
                <Icon iconName="error" wrapperStyle="tw-w-8 tw-h-8"/>
                Error Loading Data</div> 
        </div>
    }

    if (data?.investment == 0) {
        return (
            <div className="tw-flex-1 tw-w-full tw-flex tw-flex-col tw-items-center tw-justify-between">
                <div className='tw-w-full tw-text-left tw-text-xl tw-text-[#003E48]'>Trade in stocks at lowest cost</div>
                <Button variant='white-primary' rounded='full' size='lg' 
                    onClick={()=>navigateToURLorOnboarding('/stocks',isDematUser)}
                >Invest Now</Button>
            </div>
        )
    } else {
        return (
            <div className="tw-pt-4 xs:tw-pt-10 tw-w-full tw-flex tw-flex-col xs:tw-gap-1 sm:tw-gap-2 tw-justify-between">
                <div className="tw-flex tw-flex-grow tw-flex-col xs:tw-flex-row tw-justify-between">
                    <InvestmentCardField label="Current Value" primaryValue={investment.current} withTypography />
                    <InvestmentCardField label="Invested Value" primaryValue={investment.investment} alignment="right" />
                </div>
                <div className="tw-flex tw-flex-grow tw-flex-col xs:tw-flex-row tw-justify-between ">
                    <InvestmentCardField label="Unrealized P/L" primaryValue={investment.unRealizedGainLoss} secondaryValue={investment.unRealizedGainLossPercent} />
                    <InvestmentCardField label="Today's P/L" primaryValue={investment.todayPnL} secondaryValue={investment.todayPnLPercent} alignment="right"/>
                </div>
            </div>
        )
    }
}

export default StocksCardContent